<template>
  <rfq>
    <div class="cust-motor-wrap guest-quote-page">
      <motor-start-page :guest="true" />
    </div>
  </rfq>
</template>

<script>
import Rfq from '@/components/layout/Rfq';
import MotorStartPage from '@/components/motor/MotorStartPage';

export default {
  name: 'GuestMotorStart',
  components: { Rfq, MotorStartPage },
  metaInfo: { title: 'Motor insurance — Get a quote' },
};
</script>

<style src="@/assets/css/customer-motor.css"></style>
<style scoped>
.guest-quote-page {
  padding-top: 16px;
  padding-bottom: 32px;
}
</style>
